import React from 'react';
import { useDispatch, useSelector } from 'hooks/store';
import { authenticateAction, sessionIsLoadingSelector } from 'state/slices/session';

import { Form } from 'antd';
import {
  Button,
  Checkbox,
  Input,
} from 'UI';

import {
  FormContainer,
  InputContainer,
  KeepSessionContainer,
  ButtonContainer,
} from './style';

interface LoginFormData {
  email: string;
  password: string;
  shouldKeepSession: boolean;
}

const LoginForm = (): JSX.Element => {
  const [form] = Form.useForm<LoginFormData>();
  const dispatch = useDispatch();
  const isLoading = useSelector(sessionIsLoadingSelector);

  const onFinish = (data: LoginFormData) => {
    dispatch(authenticateAction({
      email: data.email,
      password: data.password,
    }));
  };

  return (
    <FormContainer
      layout="vertical"
      form={form}
      requiredMark={false}
      onFinish={onFinish as (val: unknown) => void}
    >
      <InputContainer
        label="E-mail"
        name="email"
        rules={[
          {
            required: true,
            message: 'Insira seu e-mail',
          },
        ]}
      >
        <Input placeholder="E-mail" />
      </InputContainer>
      <InputContainer
        label="Senha"
        name="password"
        rules={[
          {
            required: true,
            message: 'Insira sua senha',
          },
        ]}
      >
        <Input type="password" placeholder="Senha" />
      </InputContainer>
      <KeepSessionContainer
        name="session-checkbox"
        valuePropName="checked"
      >
        <Checkbox>
          Manter logado
        </Checkbox>
      </KeepSessionContainer>
      <ButtonContainer>
        <Button htmlType="submit" loading={isLoading}>Entrar</Button>
      </ButtonContainer>
    </FormContainer>
  );
};

export default LoginForm;
